import axios from 'axios';
import caseManagerUrl from './caseManagerUrl';
import { configureHttpHeaders, onSuccess, onError, onErrorUnresolveRTI } from './apiHelpers';

const baseUrl = caseManagerUrl();

export function submitUnresolveTakeAction(
  caseNumber,
  caseStageId,
  caseNotes,
  productivityActivityLogId,
  caseStage,
  card_brand_code,
  recordTypeIdentifier,
) {
  configureHttpHeaders(axios);
  let data = {
    caseNumber: caseNumber,
    caseStageId: caseStageId,
    caseNotes: caseNotes,
    productivityActivityLogId: productivityActivityLogId,
    caseStage: caseStage,
    card_brand_code: card_brand_code,
    recordTypeIdentifier: recordTypeIdentifier,
  };
  return postUnmatched(`api/v1/casemanager/unresolve/action`, data);
}

export function getCaseLandingData(caseNumber) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${caseNumber}`);
}

export function getCaseLandingData2(caseNumber, isView) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${caseNumber}?isView=${isView}`);
}

export function getMerchantDetails(caseNumber, disputeStageId) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${caseNumber}/${disputeStageId}/merchantdetails`);
}

export function getBankDetails(cardBrandCode, issuerBinIca, disputeStageId) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${cardBrandCode}/${issuerBinIca}/${disputeStageId}/bankdetails`);
}

export function getTakeActions(disputeStageId, cardBrandCode, statusId, caseNumber) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${disputeStageId}/${cardBrandCode}/${statusId}/actions?caseNumber=${caseNumber}`);
}

export function getActionPages(caseNumber, cardBrandCode, disputeStageId) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${caseNumber}/${cardBrandCode}/${disputeStageId}/actions/pages`);
}

export function getLedgersForCase(caseNumber, actionViewCode, acqCode) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${caseNumber}/ledger?takeActionCode=${actionViewCode}&acqCode=${acqCode}`);
}

export function fetchAuthDetails(caseNumber) {
  configureHttpHeaders(axios);
  return get(`api/v1/casemanager/case/${caseNumber}/authorization`);
}

export function updateOp1CaseData(oP1CaseDetails) {
  configureHttpHeaders(axios);
  return put(`api/v1/casemanager/case/op1`, oP1CaseDetails);
}
export function updateWexCaseData(wexCaseDetails) {
  configureHttpHeaders(axios);
  return put(`api/v1/casemanager/case/wex`, wexCaseDetails);
}

export function updateLTypeCaseData(lTypeCaseDetails) {
  configureHttpHeaders(axios);
  return put(`api/v1/casemanager/amex/case/`, lTypeCaseDetails);
}

function get(url) {
  return axios.get(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}

function put(putUrl, putData) {
  return axios({
    method: 'put',
    url: `${baseUrl}${putUrl}`,
    data: putData,
  })
    .then(onSuccess)
    .catch(onError);
}

function postUnmatched(postUrl, body) {
  return axios({
    method: 'post',
    url: `${baseUrl}${postUrl}`,
    data: body,
  })
    .then(onSuccess)
    .catch(onErrorUnresolveRTI);
}

export default {
  getCaseLandingData,
  getLedgersForCase,
};
